/* /assets/ctr-countdown-banner.js
   Drives the live clock in sections/ctr-countdown-banner.liquid.

   `data-end` is a Unix timestamp in seconds, computed server-side (see the
   section's Liquid) from the shop's timezone — so this just compares it to
   the visitor's own clock. Every visitor therefore counts down to the same
   absolute instant, regardless of where they are or how their device clock
   is set. When the countdown reaches zero, the digits are swapped for the
   merchant's configured "ended" text and the interval stops.

   Display format: while more than 24 hours remain, shows
   Days:Hours:Minutes:Seconds. Once under 24 hours remain, it automatically
   switches to Hours:Minutes:Seconds.

   Safe to run more than once (each timer only ever gets wired up once,
   guarded by a data attribute) and re-runs automatically when the theme
   editor swaps in a section, same pattern as ctr-tokyo-sip-entry-badge.js.
*/
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function startTimer(el) {
    var endSeconds = parseInt(el.getAttribute('data-end'), 10);
    var digitsEl = el.querySelector('[data-countdown-digits]');
    if (!endSeconds || !digitsEl) return;

    var endedText = el.getAttribute('data-ended-text') || 'Offer ended';
    var intervalId = null;

    function render() {
      var diff = endSeconds * 1000 - Date.now();

      if (diff <= 0) {
        digitsEl.textContent = endedText;
        el.classList.add('ctr-countdown__timer--ended');
        if (intervalId) clearInterval(intervalId);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (totalSeconds < 86400) {
        digitsEl.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      } else {
        digitsEl.textContent = pad(days) + ':' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      }
    }

    render();
    intervalId = setInterval(render, 1000);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var timers = scope.querySelectorAll('[data-countdown-timer]:not([data-ctr-countdown-init])');
    for (var i = 0; i < timers.length; i++) {
      timers[i].setAttribute('data-ctr-countdown-init', 'true');
      startTimer(timers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();